module.exports = __webpack_public_path__ + "static/bg01_sp-6dcb65969b0f3bf1206e0dd6cce6b9c5.png";